module.exports = "<section layout=\"column\" flex layout-fill>\n\t<md-toolbar class=\"md-toolbar--with-border\">\n\t\t<navbar></navbar>\n\t</md-toolbar>\n\n\t<section layout=\"row\" flex layout-fill>\n\t\t<md-sidenav\n\t\t\t\t\tclass=\"md-sidenav-left\"\n\t\t\t\t\tmd-component-id=\"left\"\n\t\t\t\t\tmd-whiteframe=\"4\"\n\t\t\t\t\tng-if=\"app.isAuthenticated()\">\n\t\t</md-sidenav>\n\n\t\t<section layout=\"column\" flex>\n\t\t\t<md-content flex layout-align=\"top center\" id=\"app\" class=\"app-container\">\n\t\t\t\t<ui-view></ui-view>\n\t\t\t</md-content>\n\t\t</section>\n\t</section>\n</section>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./sources/app.html
// module id = 3
// module chunks = 0